/**
 * Created by Yash Sharma on 07/12/18.
 */

import Menu from './Menu';
export default Menu;